import { render, staticRenderFns } from "./GeographicalDistribution.vue?vue&type=template&id=40800e8d&"
import script from "./GeographicalDistribution.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistribution.vue?vue&type=script&lang=js&"
import style0 from "./GeographicalDistribution.vue?vue&type=style&index=0&id=40800e8d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports